import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { refreshAuthData } from '../../actions/AuthAction';

const VerifyEmail = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('');
    const hasVerified = useRef(false);

    useEffect(() => {
        if (hasVerified.current) return;
        hasVerified.current = true;
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('Invalid verification link.');
            return;
        }

        const verify = async () => {
            try {
                const res = await fetch(
                    `${process.env.REACT_APP_API_BASE_URL}/auth/verify-email/${token}`,
                    { credentials: 'include' }
                );
                const data = await res.json();

                if (res.ok) {
                    setStatus('success');
                    setMessage(data.message);
                    dispatch(refreshAuthData({"user": data.user}));

                    setTimeout(() => navigate('/'), 3000);
                } else if (res.status === 400) {
                    setStatus('expired');
                    setMessage(data.message);
                } else {
                    setStatus('error');
                    setMessage(data.message);
                }
            } catch (error) {
                setStatus('error');
                setMessage('Something went wrong. Please try again.');
            }
        };

        verify();
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: 12 }}>
            {status === 'verifying' && (
                <>
                    <div style={{ fontSize: 32 }}>⏳</div>
                    <div>Verifying your email...</div>
                </>
            )}
            {status === 'success' && (
                <>
                    <div style={{ fontSize: 32 }}>✅</div>
                    <div style={{ fontWeight: 600, color: '#16a34a' }}>{message}</div>
                    <div style={{ fontSize: 13, color: '#6b7280' }}>Redirecting you to the app...</div>
                </>
            )}
            {status === 'expired' && (
                <>
                    <div style={{ fontSize: 32 }}>⏰</div>
                    <div style={{ fontWeight: 600, color: '#f97316' }}>{message}</div>
                    <div style={{ fontSize: 13, color: '#6b7280' }}>Please request a new verification link from your notifications.</div>
                    <button className="button" onClick={() => navigate('/')}>Go to App</button>
                </>
            )}
            {status === 'error' && (
                <>
                    <div style={{ fontSize: 32 }}>❌</div>
                    <div style={{ fontWeight: 600, color: '#ef4444' }}>{message}</div>
                    <button className="button" onClick={() => navigate('/')}>Go to App</button>
                </>
            )}
        </div>
    );
};

export default VerifyEmail;